import { Component, ElementRef, Inject, OnInit, signal, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-group-block-question-picker',
  templateUrl: 'group-block-question-picker.component.html',
  styleUrls: ['./group-block-question-picker.component.scss']
})
export class GroupBlockQuestionPickerComponent implements OnInit {
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  filteredQuestions$ = signal<Question[]>([]);
  selectedQuestion: Question;

  constructor(
    private dialogRef: MatDialogRef<GroupBlockQuestionPickerComponent, string>,
    @Inject(MAT_DIALOG_DATA) private data: Question[]
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-block-question-picker__dialog');
    this.filteredQuestions$.set(this.data.slice());
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onComplete(): void {
    if (this.selectedQuestion) {
      this.dialogRef.close(this.selectedQuestion.id);
    }
  }

  onQuestionSelected(event: MatAutocompleteSelectedEvent): void {
    this.selectedQuestion = this.filteredQuestions$().find((q) => q.id === event.option.value);
  }

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredQuestions$.set(
      this.data.filter((question) => question.id.toLowerCase().includes(filterValue) || question.title.toLowerCase().includes(filterValue))
    );
  }
}
